import { render, staticRenderFns } from "./UserPublicInfo.vue?vue&type=template&id=50a0ec4f&scoped=true&"
import script from "./UserPublicInfo.vue?vue&type=script&lang=js&"
export * from "./UserPublicInfo.vue?vue&type=script&lang=js&"
import style0 from "./UserPublicInfo.vue?vue&type=style&index=0&id=50a0ec4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a0ec4f",
  null
  
)

export default component.exports